import { SpecialPrice } from 'helpers/models/specialprice.model';
import React, { useEffect, useState } from 'react';
import { Button, Col, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import ErrorModal from './ErrorModal';

const SpecialPriceSelector = ({ specialPrice, onSpecialPriceChange }: { specialPrice: SpecialPrice, onSpecialPriceChange: (specialPrice: any) => void }) => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [specialPriceDTO, setSpecialPriceDTO] = useState<SpecialPrice>(new SpecialPrice());
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [showModal, setShowModal] = useState({
        isVisible: false,
        color: false,
    });
    useEffect(() => {
        if (specialPrice) {
            setSpecialPriceDTO(SpecialPrice.copy(specialPriceDTO, specialPrice));
        } else {
            setSpecialPriceDTO(new SpecialPrice());
        }
    }, [specialPrice]);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    }

    const onFieldChange = (key: string, value: any) => {
        let spPrice: any = { ...specialPriceDTO };
        spPrice[key] = value;
        setSpecialPriceDTO(spPrice);
    }

    return (
        <React.Fragment>

        <ErrorModal
          show={showModal.isVisible}
          message={errorMessage}
          color={showModal.color}
          onCloseClick={() => setShowModal({ isVisible: false, color: false })}
        />
        
            <Modal
                isOpen={isModalOpen}
                toggle={() => toggleModal()}
                backdrop="static"
            >
                <ModalHeader className="modal-title" toggle={() => toggleModal()}>
                    Special Price
                </ModalHeader>
                <ModalBody>
                    <form>
                        <Row>
                            <Col lg={7}>
                                <div className="formContainer input-group">
                                    <span style={{ fontSize: 10, padding: 10 }} className="input-group-text" id="basic-addon1">Rs</span>
                                    <Input
                                        type="number"
                                        className="form-control"
                                        id="product-title-input"
                                        placeholder="Enter Special Price"
                                        name="amount"
                                        min={1} 
                                        value={specialPriceDTO.amount && specialPriceDTO.amount > 0 ? specialPriceDTO.amount : ''}
                                       onChange={(e) => {
                                       const value = Number(e.target.value);
                                       if (!isNaN(value) && value > 0) {
                                       onFieldChange("amount", value);
                                       } else {
                                       onFieldChange("amount", 0);
                                       }
                                       }}
                                       data-testing-id="priceInput_SpecialPriceSelector"
                                       />

                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <p className="fs-6 my-3">
                                    Sales Price for a Product for Promotion. The rate of the
                                    special price must be between 0.20 and 1.00
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6}>
                                <div className="formContainer mb-3">
                                    <Label htmlFor="taskname" className="col-form-label">
                                        Start Date
                                    </Label>
                                    <Input
                                        id="taskname"
                                        name="startDate"
                                        type="datetime-local"
                                        className="form-control validate"
                                        placeholder="Set Start Date"
                                        validate={{ required: { value: true } }}
                                        onChange={(e) => onFieldChange("startDate", e.target.value)}
                                        onBlur={(e) => onFieldChange("startDate", e.target.value)}
                                        value={specialPriceDTO.startDate}
                                        data-testing-id="startDataInput_SpecialPriceSelector"
                                        min={new Date().toISOString().slice(0, 16)}
                                    />
                                </div>
                            </Col>
                            <Col sm={6}>
                                <div className="formContainer mb-3">
                                    <Label htmlFor="taskname" className="col-form-label">
                                        End Date
                                    </Label>
                                    <Input
                                        id="taskname"
                                        name="endDate"
                                        type="datetime-local"
                                        className="form-control validate"
                                        placeholder="Set End Date"
                                        validate={{ required: { value: true } }}
                                        onChange={(e) => onFieldChange("endDate", e.target.value)}
                                        onBlur={(e) => onFieldChange("endDate", e.target.value)}
                                        value={specialPriceDTO.endDate}
                                        data-testing-id="endDataInput_SpecialPriceSelector"
                                          min={
                                            specialPriceDTO.startDate
                                            ? new Date(new Date(specialPriceDTO.startDate).getTime() + 60000)
                                                .toISOString()
                                                .slice(0, 16) // startDate + 1 minute
                                            : new Date().toISOString().slice(0, 16)
                                        }
                                    />
                                </div>
                            </Col>
                        </Row>
                    </form>
                </ModalBody>
                <div className="modal-footer">
                    {specialPrice && specialPrice.amount && <Button
                        color="danger"
                        onClick={() => {
                            onSpecialPriceChange(null);
                            setIsModalOpen(false);
                        }}
                        data-testing-id="deleteButton_SpecialPriceSelector"
                    >
                        
                        Delete
                    </Button>}
                    <Button
                        color="light"
                        onClick={() => setIsModalOpen(false)}
                        data-testing-id="backButton_SpecialPriceSelector"
                    >
                        Back
                    </Button>
                    <Button color="primary"
                        onClick={() => {
                            if (
                            (specialPriceDTO.amount ?? 0) > 0 &&
                            (!specialPriceDTO.startDate || !specialPriceDTO.endDate)
                            ) {
                            // alert("Please fill both Start Date and End Date if Special Price is set");
                                     setErrorMessage("Please fill both Start Date and End Date if Special Price is set!");
                                    setShowModal({ isVisible: true, color: false });
                                    setTimeout(() => {
                                        setShowModal({ isVisible: false, color: false });
                                    }, 3000);
                            return;
                            }
                            onSpecialPriceChange(specialPriceDTO);
                            setIsModalOpen(false);
                        }}
                         data-testing-id="okButton_SpecialPriceSelector"
                    >
                        Ok
                    </Button>
                </div>
            </Modal>

            <Button color="primary" data-testing-id="addButton_SpecialPriceSelector" outline className='btn btn-ghost-primary' onClick={() => toggleModal()} >{specialPrice && specialPrice.amount ? specialPrice.amount : 'Add'}</Button>

        </React.Fragment>
    );
};

export default SpecialPriceSelector;